export function getPendingMarkup(): string {
    return '<span class="c-chat__message--pending"><span></span><span></span><span></span></span>';
}